<template>
	<div class='followList'>
		<div
			class="practice_item"
			v-for="(el, i) in Plist"
			:key="i"
			:style="{ borderTop: i ? '1rpx #EDEDED solid' : '' }"
		>
			<div
				class="practice_top"
				@click="goUserDetails(el)"
			>
				<div class="toux_box">
					<img
						v-if="i < 3"
						:src="$store.state.wqurl + `decoration${i + 1}_img.png`"
						mode=""
					>
					<div class="toux">
						<img
							:src="el.headImg"
							mode=""
						>
					</div>
				</div>
				<div class="practice_name">
					<div class="">
						<text>{{ el.nickName ? el.nickName : el.realName }}</text>
					</div>
					<div class="info">{{ el.worksNum || 0 }} 作品 | {{ el.praiseNum || 0 }} 获赞 |
						{{ el.fansNum || 0 }}
						粉丝
					</div>
				</div>
				<div class="caoz">
					<el-button
						type="primary"
						size="small"
						round
						@click.stop="isInterest(el)"
					>{{el.activated ? '已关注':'关注'}}</el-button>

					<!-- <div
						class="gm_box"
						@click.stop="wqAttentionDetail(el)"
					>咨询</div> -->
				</div>
			</div>
		</div>

		<div
			class="kong"
			v-if="Plist.length == 0"
		>
			<img
				:src="$store.state.wqurl + 'all_page_nullTowImg.png'"
				alt=""
			>

			暂无数据
		</div>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  attentionServiceUser,
  clickCancelInterest,
  clickInterest,
} from "@/api/professionServer";
export default {
  name: "followList",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      page: 1,
      Plist: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 获取关注列表
    async queryList() {
      this.Plist = [];
      let opt = {
        page: this.page,
        limit: 10,
        orderBy: "DESC",
        orderType: 1,
      };
      let res = await attentionServiceUser(opt);
      if (res.code !== 200) {
        return;
      }
      this.Plist = res.data.data.map((item) => {
        item.activated = true;
        return item;
      });

      console.log(this.Plist);
    },

    async isInterest(val) {
      if (!val.attention) {
        this.$confirm("取消关注, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            val.activated = false;
            clickCancelInterest(val.userId);
          })
          .catch(() => {});
      } else {
        val.activated = true;
        clickInterest(val.userId);
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.queryList();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
.followList {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 15px;
  gap: 20px;

  .practice_item {
    width: 48%;
    padding: 15px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    .practice_top {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .toux_box {
        position: relative;
        width: 68px;
        height: 68px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 5px;

        > img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        .toux {
          width: 50px;
          height: 50px;
          background-color: #30201e;
          border-radius: 50%;
          overflow: hidden;

          > img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .practice_name {
        > view:first-child {
          font-size: 17rpx;
          font-weight: bold;
          color: #f63c3d;
          display: flex;
          align-items: center;
        }

        > view:last-child,
        .info {
          font-size: 12px;
          color: #a5a8b0;
          margin-top: 10px;
        }
      }

      .interest_box {
        width: 60px;
        text-align: center;
        padding: 5px 0;
        background: #326afb;
        border-radius: 20px;
        font-size: 13px;
        font-weight: bold;
        color: #ffffff;
      }

      .inter2 {
        background-color: #ebf1ff;
        color: #326afb;
      }
    }
  }

  .kong {
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 14px;
    gap: 10px;
    color: #a6a9b1;
    justify-content: center;
    height: 100%;
    width: 100%;

    img {
      width: 130px;
    }
  }
}
</style>